export default "__VITE_ASSET__DQogckdc__"